import { normalizeAdvertiserGroups } from '@/lib/adapters/advertiser-groups.adapter'
import { normalizeImage } from '@/lib/adapters/image.adapter'
import { normalizeTrafficSourcesCosts } from '@/lib/adapters/traffic-source-costs.adapter'
import type {
  AdvertiserInvoice,
  AdvertiserLegacyType,
  AdvertiserServerLegacyType,
  AdvertiserServerType,
  AdvertiserType,
  ApiAdvertiserInvoice,
} from '@/lib/types/advertiser.types'

const normalizeAdditionalPayments = (payments: AdvertiserServerLegacyType['one_time_earnings']) => {
  return payments.map((payment) => ({
    id: payment.id,
    invoiceAmount: payment.invoice_amount / 100,
    userEarnings: payment.user_earnings / 100,
    date: payment.payment_date,
    title: payment.comment,
    user: payment.user && {
      id: payment.user.id,
      username: payment.user.username,
    },
  }))
}

export const normalizeInvoices = (invoices: ApiAdvertiserInvoice[]): AdvertiserInvoice[] => {
  return invoices.map((invoice) => ({
    id: invoice.id,
    amount: invoice.total / 100,
    date: invoice.invoice_date,
    currency: invoice.currency,
    paidAt: invoice.paid_at,
    status: invoice.status,
    url: invoice.url,
    creditInvoiceUrl: invoice.credit_invoice_url,
  }))
}

export const normalizeAdvertiser = (data: AdvertiserServerLegacyType): AdvertiserLegacyType => {
  return {
    id: data.id,
    // logo: data.logo_url,
    logo: data.logo ? normalizeImage(data.logo) : { url: data.logo_url },
    name: data.feed_name,
    currency: data.currency_iso_code,
    advertiserGroups: normalizeAdvertiserGroups(data.store_groups),
    provider: data.feed_provider,
    type: data.store_type,
    trafficSourceCosts: normalizeTrafficSourcesCosts(
      data.traffic_sources_costs,
      data.currency_iso_code,
    ),
    language: data.language_iso_code,
    additionalPayments: normalizeAdditionalPayments(data.one_time_earnings),
  }
}

export const normalizeAdvertiserItem = (advertiser: AdvertiserServerType): AdvertiserType => {
  // TODO: this should be a separate adapter, however, we need to first figure out the types for Advertiser
  return {
    id: advertiser.id,
    logo: normalizeImage(advertiser.logo),
    name: advertiser.name,
    currency: advertiser.currency,
  }
}

export const normalizeAdvertiserItems = (advertisers: AdvertiserServerType[]): AdvertiserType[] => {
  return advertisers.map((advertiser) => normalizeAdvertiserItem(advertiser))
}
